import React from 'react';
import PropTypes from 'prop-types';
import 'react-tabs/style/react-tabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PrincipalBondResultList from './PrincipalBondResultList';
import StatusList from './StatusList';
import CostResultList from './CostResultList';
import PaymentResultList from './PaymentResultList';
import StatusChart from './StatusChart';
import ReturnResultList from './ReturnResultList';
import ReturnSummaryResultList from './ReturnSummaryResultList';


const ResultTab = ({ data }) => {
  if (!data || Object.keys(data).length === 0){
    return (
      <div/>
    );
  }

  console.log("data", data);
  let result = data;

  return (
    <div>    
      <div className="grid">              
        <div className="col s6of12">            
          <StatusList data={result}/>
        </div>   
        <div className="col s6of12">
          <StatusChart data={result}/>
        </div>         
      </div>      

      <div className="grid">              
        <div className="col s12of12">            
          {result.legs && result.legs.length > 0 ? <PrincipalBondResultList data={result.legs[0].principals}/> : null}
        </div>        
      </div>      

      <div className="grid">              
        <div className="col s8of12">            
          <CostResultList data={result.costs} />
        </div>    
        <div className="col s4of12">
          <StatusChart data={result.costs}/>
        </div>    
      </div>      

      <div className="grid">              
        <div className="col s8of12">            
          <PaymentResultList data={result.payments} />
        </div>    
        <div className="col s4of12">
          <StatusChart data={result.payments}/>
        </div>    
      </div>    

      <div className="grid">              
        <div className="col s8of12">            
          <ReturnSummaryResultList data={result.returnStatus} />
        </div>    
        <div className="col s4of12">
          <ReturnResultList data={result.returns}/>
        </div>    
      </div>  
      

    </div>
  );
};

ResultTab.propTypes = {
  data: PropTypes.object,
};

export default ResultTab;
